
import { Component, Vue } from 'vue-property-decorator';
import ExpandIcon from "@/components/utils/ExpandIcon.vue";

@Component({
    components:{
        ExpandIcon
    }
})
export default class BookAppealDateAppRightToAppealPg extends Vue { 

    showAppealReadyInfo = true;
    showObtainInfo = false;
    showExpediteInfo = false;

    public showAppealReady(show: boolean){
        if (show) {
            this.showAppealReadyInfo = true;
            this.$emit('adjustHeights', 0, "7rem")
        } else {
            this.showAppealReadyInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showObtain(show: boolean){
        if (show) {
            this.showObtainInfo = true;
            this.$emit('adjustHeights', 1, "9.5rem")
        } else {
            this.showObtainInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showExpedite(show: boolean){
        if (show) {
            this.showExpediteInfo = true;
            this.$emit('adjustHeights', 2, "13rem")
        } else {
            this.showExpediteInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

}
